import React from 'react'
import {
   AIDrivenSmartTravelIcon,
   ContinuousSupportIcon,
   CustomTailoredTravelIcons,
   OmnichannelTravelIcon,
   ScalableCloudBasedIcon,
   SecureTransactionsIcon,
} from '@/svgs'
import { WhyChooseOur } from '@/components'

const featureCards = [
   {
      title: 'Custom-Tailored Travel Solutions',
      subtitle: 'Personalized Platforms for Travel Businesses',
      description:
         'In the range between B2B and B2C travel web portals and multi-vendor portals, we construct customized travel web sites to specifically serve travel companies, airlines, hotels, and tour operators.',
      icon: <CustomTailoredTravelIcons />,
   },
   {
      title: 'Secure & Compliant Transactions',
      subtitle: 'Ensuring Payment & Data Security',
      description:
         'We employ fraud prevention tools, encryption methods, and regulatory compliance (GDPR, PCI-DSS) to safeguard sensitive customer information and secure transactions.',
      icon: <SecureTransactionsIcon />,
   },
   {
      title: 'AI & Automation for Smart Travel Management',
      subtitle: 'Enhancing Booking Efficiency & Personalization',
      description:
         'Our AI-powered travel solutions make travel easier and more effective by offering chatbot assistance, automated booking processes, personalized itinerary planning, and predictive pricing.',
      icon: <AIDrivenSmartTravelIcon />,
   },
   {
      title: 'Omnichannel Travel Booking Experiences',
      subtitle: 'Seamless Travel Management Across Platforms',
      description:
         'We create omnichannel travel solutions that combine web, mobile applications, voice assistants, and social media platforms, providing travelers with a single and convenient booking process.',
      icon: <OmnichannelTravelIcon />,
   },
   {
      title: 'Scalable Cloud-Based Travel Solutions',
      subtitle: 'Optimizing Performance & Cost Efficiency',
      description:
         'Our cloud-based travel technology provides high availability, quick response times, and synchronous data updates in real-time to support businesses with seasonal peak demand and operational optimization.',
      icon: <ScalableCloudBasedIcon />,
   },
   {
      title: 'Continuous Support & Feature Enhancements',
      subtitle: 'Ensuring Long-Term Stability & Innovation',
      description:
         'We offer 24/7 technical assistance, continuous updates, and feature updates to help travel applications stay competitive, secure, and up-to-date with industry trends.',
      icon: <ContinuousSupportIcon />,
   },
];

function TravelWhyChoose() {
   return (
      <>
         <WhyChooseOur
         classCustom='fintech_custom_why_choose'
            title={
               'Why Select Our Travel & Tourism Software Development Services?'
            }
            desc={
               'We design secure, flexible, and consumer-focused travel products meant to add value to travellers\' experiences, improve operations, and increase businesses.Here’s why businesses choose Benzatine:'
            }
            cardData={featureCards}
            otherUi={true}
         />
      </>
   )
}

export default TravelWhyChoose
